import './load.css';

const LoadingSpinner = () => (
  <div className="spinner-container">
    <div className="loading-spinner" />
  </div>
);

export default LoadingSpinner;
